"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebhookEventType = void 0;
var WebhookEventType;
(function (WebhookEventType) {
    WebhookEventType["CONVERSATION_ANALYSIS"] = "conversation_analysis";
    WebhookEventType["AVATAR_UPDATED"] = "avatar_updated";
    WebhookEventType["AVATAR_DELETED"] = "avatar_deleted";
    WebhookEventType["KNOWLEDGE_NOTIFY"] = "knowledge_notify";
    WebhookEventType["AVATAR_TEST_COMPLETE"] = "avatar_test_complete";
})(WebhookEventType || (exports.WebhookEventType = WebhookEventType = {}));
